import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor(private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/sgkz001d') {
          this.onChangeSelected('');
        }
      };
    });
  }

  /** データ変更を通知するためのオブジェクト */
  private selectedMenuSubject = new BehaviorSubject<string>('');

  get selectedMenuChanges() {
    return this.selectedMenuSubject.asObservable();
  }

  /**
   * データ更新イベント
   *
   * @param {string} menuId
   * @memberof MenuService
   */
  public onChangeSelected(menuId: string) {
    console.log(menuId);
    this.selectedMenuSubject.next(menuId);
  }

  /**
   * 業務画面表示
   *
   * @param {string} menuId
   * @memberof MenuService
   */
  public nextRoute(menuId: string) {
    // 対象業務画面に遷移
    this.router.navigate([menuId]);
  }
}
